import styled from 'styled-components';

import { Container } from '@thinkific/toga-react';

const wrapped = styled(Container)`
  box-sizing: border-box;
`;

export default wrapped;
